import { Box, type BoxProps } from '@frontend/legacy-components';

export type SearchOverlayProps = BoxProps;

export const SearchOverlay = ({ onClick, zIndex = 500, ...rest }: BoxProps) => (
  <Box
    onClick={onClick}
    bg="overlay.modal"
    position="fixed"
    top={0}
    left={0}
    bottom={0}
    right={0}
    zIndex={zIndex}
    {...rest}
  />
);
